var map = {
	"./Participant/resources/components/canvas/blocks/modules/participant/admin/BlockPanel.vue": 94667,
	"./WebsiteNews/resources/components/canvas/blocks/modules/news/admin/BlockPanel.vue": 66946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31335;